import { createContext, useContext } from 'react';
import { jsxs as _jsxs } from "react/jsx-runtime";
export var ConfigurationContext = /*#__PURE__*/createContext(undefined);
export var ConfigurationProvider = function ConfigurationProvider(_ref) {
  var initial = _ref.initial,
      children = _ref.children;
  return /*#__PURE__*/_jsxs(ConfigurationContext.Provider, {
    value: initial,
    children: [" ", children, " "]
  });
};
export var useConfigurationContext = function useConfigurationContext() {
  var context = useContext(ConfigurationContext);

  if (context) {
    return context;
  }

  throw new Error('ConfigurationContext value must be set.');
};